import { Routes } from '@angular/router';
import { EVFunctions } from 'ets-fe-ng-sdk';

export const PolicyDeskRoutes: Routes = [
  {
    path: `fraud`,
    children: [
      {
        path: `search`,
        data: { title: `Search Fraud` },
        loadComponent: () =>
          import('./fraud/find-fraud/find-fraud.component').then((c) => c.FindFraudComponent),
      },
      ...EVFunctions.extendRoute2({
        data: { title: `Fraud` },
        loadComponent: () =>
          import('./fraud/save-fraud/save-fraud.component').then((c) => c.SaveFraudComponent),
      }),
      { path: ``, pathMatch: 'full', redirectTo: 'search' },
    ],
  },
  {
    path: `production-data`,
    children: [
      {
        path: `find`,
        data: { title: `Production Data` },
        loadComponent: () =>
          import('./production-data/production-data.component').then((c) => c.ProductionDataComponent),
      },
      {
        path: `view`,
        data: { title: `View Production` },
        loadComponent: () =>
          import('./production-data/view-production/view-production.component').then(
            (c) => c.ViewProductionComponent,
          ),
      },
      ...EVFunctions.extendRoute2({
        data: { title: `Receipt` },
        loadComponent: () =>
          import('./production-data/save-production-data/save-production-data.component').then(
            (c) => c.SaveProductionDataComponent,
          ),
      }),
      { path: ``, pathMatch: 'full', redirectTo: 'find' },
    ],
  },

  {
    path: `policy-data`,
    children: [
      {
        path: `find`,
        data: { title: `Policy Data` },
        loadComponent: () => import('./policy-data/policy-data.component').then((c) => c.PolicyDataComponent),
      },
      {
        path: `view`,
        data: { title: `View Policy` },
        loadComponent: () =>
          import('./policy-data/view-policy/view-policy.component').then((c) => c.ViewPolicyComponent),
      },
      ...EVFunctions.extendRoute2({
        data: { title: `Save Policy` },
        loadComponent: () =>
          import('./policy-data/save-policy/save-policy.component').then((c) => c.SavePolicyComponent),
      }),
      { path: ``, pathMatch: 'full', redirectTo: 'find' },
    ],
  },
  {
    path: `validate`,
    data: { title: `Validate Policy` },
    loadComponent: () =>
      import('./policy-data/validate-policy/validate-policy.component').then(
        (c) => c.ValidatePolicyComponent,
      ),
  },
  {
    path: `logs`,
    data: { title: `Validation Logs` },
    loadComponent: () =>
      import('./policy-data/validation-logs/validation-logs.component').then(
        (c) => c.ValidationLogsComponent,
      ),
  },
  {
    path: `commissions`,
    data: { title: `Policy Commissions` },
    loadComponent: () =>
      import('./policy-commissions/policy-commissions.component').then((c) => c.PolicyCommissionsComponent),
  },
];

export default PolicyDeskRoutes;
